import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!

  return (_openBlock(), _createBlock(_component_ion_col, {
    class: "ion-col",
    style: _normalizeStyle(_ctx.backgroundStyle),
    size: _ctx.isPortraitOrientation ? '12' : '6'
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "content-block",
        style: _normalizeStyle(_ctx.contentPadding),
        innerHTML: _ctx.promoBlock?.content,
        ref: "contentRef"
      }, null, 12, _hoisted_1)
    ]),
    _: 1
  }, 8, ["style", "size"]))
}